module.exports = __webpack_public_path__ + "static/media/balloons-ten.5a1e0144.svg";